import { create } from "zustand";

export const useActiveAbilityStore = create((set) => ({
  activeAbility: null,
  setActiveAbility: (ability) => set({ activeAbility: ability }),
}));
